import MuiListItemIcon from '@mui/material/ListItemIcon';
import { styled } from '@mui/material/styles';

const ListItemIcon = styled(MuiListItemIcon)(() => ({
  color: 'var(--icon)',
}));

export default ListItemIcon;
